import { LightbulbVariantOutlineIcon } from './LightbulbVariantOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 70DD894F-1717-4C05-9C34-D7CE1ACF36CC
 * name lightbulb-variant-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const LightbulbFilamentOutlineIcon = LightbulbVariantOutlineIcon;
export default LightbulbFilamentOutlineIcon